export const getLayoutData = ({ layout, bankNavigationSettings, bankSeoSettings }) => {
  layout.headerData.hideMainNavigation = bankNavigationSettings?.hide_main_navigation ?? false;
  layout.footerData.hideFooterLinks = bankNavigationSettings?.hide_footer_links ?? false;
  layout.footerData.hideFooter = bankNavigationSettings?.hide_footer ?? false;

  if (bankSeoSettings?.opengraph?.image) {
    bankSeoSettings.opengraph.image.url = new URL(bankSeoSettings.opengraph.image.url);
  }
  return {
    layout,
    bankSeoSettings,
  };
};

export const getPathParts = (asPath) => {
  const urlParts = asPath.split('?');
  const pathParts = urlParts[0].split('/').filter((urlPart) => urlPart);
  return pathParts;
};

export const isBankOfferIdValid = (bankPage) => {
  const bankOffersIds = bankPage.bank_offers.map((item: { id: string }) => item.id);
  return bankOffersIds.includes(bankPage.bank_offer_id as string);
};
